import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
  computed: {
    ...mapGetters({
      getLocale: 'language/getLocale'
    }),
  },
  methods: {
    ...mapActions({
      setLocale: 'language/setLocale'
    }),
  },
});
